<template>
  <div class="bulk-bar" data-test="bulk-bar">
    <span class="bulk-count">{{ count }} selected</span>

    <div class="bulk-actions">
      <b-button
        v-if="canDownload"
        size="sm"
        variant="outline-secondary"
        data-test="bulk-download"
        aria-label="Download"
        title="Download"
        @click="$emit('download')"
      >
        <b-icon icon="download" class="mr-sm-1" />
        <span class="bulk-label">Download</span>
      </b-button>
      <b-button
        v-if="canShare"
        size="sm"
        variant="outline-secondary"
        data-test="bulk-share"
        aria-label="Share"
        title="Share"
        @click="$emit('share')"
      >
        <b-icon icon="cursor" class="mr-sm-1" />
        <span class="bulk-label">Share</span>
      </b-button>

      <template v-if="canMove">
        <b-dropdown
          v-if="addFolders.length"
          size="sm"
          variant="outline-secondary"
          boundary="window"
          data-test="bulk-add-to-folder"
          :toggle-attrs="{
            'aria-label': 'Add to folder',
            title: 'Add to folder',
          }"
        >
          <template #button-content>
            <b-icon icon="folder-plus" class="mr-sm-1" />
            <span class="bulk-label">Add to folder</span>
          </template>
          <b-dropdown-item-button
            v-for="folder in addFolders"
            :key="folder.id"
            @click="$emit('add-to-folder', folder.id)"
          >
            {{ folder.path || folder.label }}
          </b-dropdown-item-button>
        </b-dropdown>
        <b-dropdown
          v-if="removeFolders.length"
          size="sm"
          variant="outline-secondary"
          boundary="window"
          data-test="bulk-remove-from-folder"
          :toggle-attrs="{
            'aria-label': 'Remove from folder',
            title: 'Remove from folder',
          }"
        >
          <template #button-content>
            <b-icon icon="folder-minus" class="mr-sm-1" />
            <span class="bulk-label">Remove from folder</span>
          </template>
          <b-dropdown-item-button
            v-for="folder in removeFolders"
            :key="folder.id"
            @click="$emit('remove-from-folder', folder.id)"
          >
            {{ folder.path || folder.label }}
          </b-dropdown-item-button>
        </b-dropdown>
      </template>

      <b-button
        v-if="canDelete"
        size="sm"
        variant="outline-secondary"
        data-test="bulk-delete"
        aria-label="Delete"
        title="Delete"
        @click="$emit('delete')"
      >
        <b-icon icon="trash" class="mr-sm-1" />
        <span class="bulk-label">Delete</span>
      </b-button>
    </div>

    <button
      type="button"
      class="bulk-clear"
      data-test="bulk-clear"
      @click="$emit('clear')"
    >
      Clear
    </button>
  </div>
</template>

<script>
export default {
  props: {
    count: { type: Number, default: 0 },
    addFolders: { type: Array, default: () => [] },
    removeFolders: { type: Array, default: () => [] },
    canDownload: { type: Boolean, default: false },
    canShare: { type: Boolean, default: false },
    canMove: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.bulk-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  background-color: #e8f0ff;
  border-bottom: 1px solid #e5e7eb;
}

/* On phones the buttons shrink to their icons so the bar stays on one or two rows. */
@media (max-width: 575.98px) {
  .bulk-label {
    display: none;
  }

  .bulk-bar {
    padding: 8px 10px;
  }
}

.bulk-count {
  color: #006cff;
  font-size: 14px;
  font-weight: 700;
}

.bulk-actions {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 8px;
}

.bulk-clear {
  padding: 0;
  background: transparent;
  border: 0;
  color: #374151;
  font-size: 14px;
}

.bulk-clear:hover {
  text-decoration: underline;
}
</style>
